import { Textarea } from "@/components/ui/textarea";
import { ROLES } from "@/lib/api";
import { Field, DayChips } from "./kit";

export const VolunteerFields = ({ f, setF, schedule }) => (
  <div className="rise space-y-5 rounded-md border border-emerald-700/50 bg-emerald-950/30 p-4" data-testid="register-volunteer-fields">
    <Field label="Preferred role">
      <div className="flex flex-wrap gap-2">
        {ROLES.map((r) => (
          <button
            type="button"
            key={r.value}
            aria-pressed={f.volunteer_role === r.value}
            data-testid={`register-volunteer-role-${r.value}`}
            onClick={() => setF({ ...f, volunteer_role: r.value })}
            className={`rounded-full border px-4 py-2 text-sm transition-colors duration-200 ${
              f.volunteer_role === r.value ? "border-emerald-500 bg-emerald-600/25 text-emerald-200" : "border-neutral-800 text-neutral-400 hover:border-neutral-600"
            }`}
          >
            {r.label}
          </button>
        ))}
      </div>
    </Field>
    <Field label="Days available to volunteer">
      <DayChips value={f.volunteer_days} onChange={(v) => setF({ ...f, volunteer_days: v })} schedule={schedule} prefix="register-volunteer" />
    </Field>
    <Field label="Volunteer notes (optional)" id="reg-vol-notes">
      <Textarea
        id="reg-vol-notes"
        data-testid="register-volunteer-notes-input"
        value={f.volunteer_notes}
        onChange={(e) => setF({ ...f, volunteer_notes: e.target.value })}
        maxLength={1000}
        className="min-h-[88px] border-neutral-800 bg-neutral-950 text-base"
        placeholder="Skills, availability, anything we should know"
      />
    </Field>
  </div>
);
